import { render, staticRenderFns } from "./TaskLocationDetailItems.component.vue?vue&type=template&id=f8e1510c&scoped=true&"
import script from "./TaskLocationDetailItems.component.vue?vue&type=script&lang=js&"
export * from "./TaskLocationDetailItems.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e1510c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
